import { Icon, Modal, Text } from 'components'

import styles from './styles.module.scss'

const CVV = () => (
  <Modal.Content className={styles.container}>
    <div className={styles.content}>
      <Icon width={48} color="element-default" name="question" />

      <Modal.Title className={styles.title}>O que é “CVV”?</Modal.Title>

      <Text as="p" weight="regular">
        É o código de verificação de 3 a 4 dígitos localizado no verso do
        cartão.
      </Text>
    </div>

    <Modal.Footer className={styles.footer}>
      <div className={styles.actions}>
        <Modal.Close asChild>
          <button>Voltar</button>
        </Modal.Close>
      </div>
    </Modal.Footer>
  </Modal.Content>
)

export default CVV
